import { Box, Tab as TabComponent, Tabs as MuiTabs } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { TabsProps } from './types';

const Tabs = ({
  a11yProps,
  ContainerProps,
  disabledIndexes,
  tabs,
  typographyVariant,
  variant = 'standard',
  ...props
}: TabsProps) => {
  const theme = useTheme();

  return (
    <Box {...ContainerProps}>
      <MuiTabs
        variant={variant}
        TabIndicatorProps={{
          sx: {
            backgroundColor: theme.palette.colors.purple[500],
            height: '1px',
          },
        }}
        {...props}
      >
        {tabs.map((tab, index: number) => {
          const isDisabled = disabledIndexes?.includes(index);
          return (
            <TabComponent
              key={index}
              label={tab}
              disabled={isDisabled}
              sx={theme => ({
                ...theme.typography[typographyVariant],
                '&.Mui-disabled': {
                  color: `${theme.palette.colors.grey[400]}`,
                },
                '&.Mui-selected': {
                  color: theme.palette.colors.black,
                },
                '&:hover': {
                  borderBottom: '1px',
                  borderBottomColor: theme.palette.colors.purple[300],
                  borderBottomStyle: 'solid',
                  color: theme.palette.colors.grey[800],
                },
                borderBottom: '1px solid transparent',
                color: theme.palette.colors.grey[600],
                padding: `12px ${variant === 'fullWidth' ? 8 : 16}px`,
              })}
              {...a11yProps(index)}
            />
          );
        })}
      </MuiTabs>
    </Box>
  );
};

export default Tabs;
